module.exports = __webpack_public_path__ + "img/Logo-34.7c47408d.svg";